<template>
  <div>
      <h1>
          URL not found
      </h1>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>